module.exports = __webpack_public_path__ + "img/logo.a5c3c81f.png";